import { Component, Input, AfterViewInit } from '@angular/core';

import { LayoutManagerService } from '../services/layout/layout-manager.service';
declare var $;
@Component({
  selector: "dskl-peers",
  templateUrl: 'peers.component.html',
  styleUrls: ['peers.style.css']
})
export class PeersComponent implements AfterViewInit {
  constructor(private layoutManager: LayoutManagerService) {
    this.layoutManager.hideVideos.subscribe(
      () => {
        this.isHidden = !this.isHidden;
      }
    )
  }
  @Input() peers = []
  public isHidden = false;

  keys() {
  
    return Object.keys(this.peers);
  }

  ngAfterViewInit() {
    if (this.layoutManager.isVideosWb()) {
      var w = $("body").width();
      //$("#peers").css("width", w);
      console.log("Set peers width to " + w);
    }
  }
  getPeerVideosWb() {
    return this.layoutManager.isVideosWb();
  }
  getPeerAudiosWb() {
    return this.layoutManager.isAudiosWb();
  }
}



// WEBPACK FOOTER //
// /app/src/app/wb/peers/peers.component.ts